import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApproveDemandTaskComponent } from './forms/approve-demand-task/approve-demand-task.component';
import { WorkflowUtilsModule, TaskHintDisplayModule, UnclaimedModule } from '@lib/workflow-integration';
import { TranslateModule } from '@ngx-translate/core';
import { PersonModule } from '@lib/user';
import { DemandModule } from '../demand/demand.module';
import { ApproveDeclineReworkTaskComponent } from './forms/approve-decline-rework-task/approve-decline-rework-task.component';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReworkPurchaseRequisitionTaskComponent } from './forms/rework-purchase-requisition-task/rework-purchase-requisition-task.component';
import { RequiredUtilsModule } from '@lib/util';
import { PurchaseRequisitionModule } from '../purchase-requisition/purchase-requisition.module';
import { CopyToClipboardModule, excludeFromTreeShaking } from '@lib/core';
import { PurchaseRequisitionChooseSingleApproverTaskComponent } from './forms/choose-single-approver/purchase-requisition-choose-single-approver-task.component';
import { IimAutocompleteModule, IimSpinnerModule } from '@iim-angular/components';
import { PostAnnouncePurchaseRequisitionTaskComponent } from './post-announce-purchase-requisition-task/post-announce-purchase-requisition-task.component';
import { PurchaseRequisitionApproveWithResultSelectionComponent } from './forms/approve-with-result-type-selection/purchase-requisition-approve-with-result-selection.component';
import { PurchaseRequisitionChooseSingleApproverDialogComponent } from './forms/choose-single-approver/dialog/purchase-requisition-choose-single-approver-dialog/purchase-requisition-choose-single-approver-dialog.component';

excludeFromTreeShaking(ReworkPurchaseRequisitionTaskComponent);
excludeFromTreeShaking(ApproveDeclineReworkTaskComponent);
excludeFromTreeShaking(ApproveDemandTaskComponent);
excludeFromTreeShaking(PurchaseRequisitionChooseSingleApproverTaskComponent);
excludeFromTreeShaking(PurchaseRequisitionApproveWithResultSelectionComponent);

@NgModule({
    declarations: [
        ApproveDemandTaskComponent,
        ApproveDeclineReworkTaskComponent,
        ReworkPurchaseRequisitionTaskComponent,
        PurchaseRequisitionChooseSingleApproverTaskComponent,
        PostAnnouncePurchaseRequisitionTaskComponent,
        PurchaseRequisitionApproveWithResultSelectionComponent,
        PurchaseRequisitionChooseSingleApproverDialogComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        PersonModule,
        DemandModule,
        MatButtonModule,
        ReactiveFormsModule,
        RequiredUtilsModule,
        PurchaseRequisitionModule,
        CopyToClipboardModule,
        WorkflowUtilsModule,
        UnclaimedModule,
        IimAutocompleteModule,
        IimSpinnerModule,
        FormsModule,
        TaskHintDisplayModule,
    ],
})
export class WorkflowRfqModule {}
